import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

import StyledPopover from '../Popover/styles';

export const StyledPlanSlider = styled.div`
  ${StyledPopover} {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;

    [role='tooltip'] {
      cursor: initial;
      text-align: center;

      p {
        margin: 0;
      }
    }

    @media (max-width: ${themeGet('breakpoint.breakpointPricingLarge')}) {
      [role='tooltip'] {
        justify-content: flex-end;
        transform: translate(calc(-100% + 16px), calc(-100% - 15px));
      }

      [role='tooltip']::after {
        left: auto;
        right: 9px;
      }
    }
  }

  .rc-slider {
    position: relative;
    width: 100%;
    height: ${themeGet('scale.scaleDown01')};
    padding: ${themeGet('scale.scaleDown04')} 0;
    border-radius: ${themeGet('scale.scaleDown04')};
    box-sizing: border-box;
    touch-action: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    user-select: none;
  }

  .rc-slider * {
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .rc-slider-rail {
    position: absolute;
    width: 100%;
    height: ${themeGet('scale.scaleDown03')};
    background-color: ${themeGet('color.colorGrayBlue30')};
    border-radius: ${themeGet('scale.scaleDown03')};
  }

  .rc-slider-track {
    position: absolute;
    left: 0;
    height: ${themeGet('scale.scaleDown03')};
    background-color: ${themeGet('color.colorBlue')};
    border-radius: ${themeGet('scale.scaleDown03')};
  }

  .rc-slider-handle {
    position: absolute;
    width: ${themeGet('scale.scaleUp03')};
    height: ${themeGet('scale.scaleUp03')};
    margin-top: -9px;
    margin-left: -12px;
    transform: none !important;
    cursor: pointer;
    cursor: grab;
    background-color: ${themeGet('color.colorWhite')};
    border: solid ${themeGet('border.borderSmall')}
      ${themeGet('color.colorBlue')};
    border-radius: 50%;
    touch-action: pan-x;
  }

  .rc-slider-handle:focus {
    outline: none;
  }

  .rc-slider-handle:active {
    cursor: grabbing;
  }
`;

export const StyledMinMaxLabels = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${themeGet('scale.scaleBase')};
  margin-bottom: ${themeGet('scale.scaleDown04')};
  font-family: "Whitney SSm A", "Whitney SSm B", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: ${themeGet('scale.scaleDown01')};
  font-weight: ${themeGet('fontWeight.fontWeightMedium')};
  color: ${themeGet('color.colorGrayBlue70')};
`;

export const StyledSliderSubText = styled.p`
  margin: ${themeGet('scale.scaleDown02')} 0 0;
  font-family: "Whitney SSm A", "Whitney SSm B", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: ${themeGet('fontWeight.fontWeightMedium')};
  color: ${themeGet('color.colorGrayBlue100')};
  font-size: ${themeGet('scale.scaleBase')};
`;
